import { useMutation, useQueryClient } from "@tanstack/react-query";
import { IAuthApi } from "@/api/auth";
import { SERVICES_TYPES, useInjection } from "@/ioc";
import { RegisterOrganizationDto } from "@/models/organization/RegisterOrganizationDto";

export const useRegisterOrganization = () => {
  const authApi = useInjection<IAuthApi>(SERVICES_TYPES.AUTH);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: RegisterOrganizationDto) => authApi.register(data),
    onSuccess: () => {
      // Invalidate organizations query to refetch the list
      queryClient.invalidateQueries({ queryKey: ["organizations"] });
    }
  });
};
